import React from "react"
import { Message } from "semantic-ui-react"
import {
  ILocalizedString,
  Multilang,
} from "../../../models/product/multilang-string"
import { StateFromReducersMapObject } from "../../../utils/combine-reducer"
import { getlangFromCache } from "../../../utils/langs"
import {
  DropdownOptionRawValue,
  DropdownOptionValue,
  FieldDataType,
  IDropdownOption,
  IFieldReducers,
  IFieldState,
} from "../../product-form/_reducers/_utils/product-form-types"

export const checkInputValueIntegrity = (
  data: IFieldState<any>,
  numeric: boolean
) => {
  if (!numeric) {
    return data.value
  }

  if (Multilang.String.IsMultilangString(data.value)) {
    return Multilang.String.GetValue(data.value, getlangFromCache(), true)
  }

  return data.value
}

export const checkDropdownValueIntegrity = (
  data: IFieldState<any>,
  options: Array<IDropdownOption<DropdownOptionRawValue>>,
  isMultiple: boolean
) => {
  const defaultValue = data.regenerateInfos.defaultValue
  const rawValue = data.value
  let value: DropdownOptionValue = defaultValue
  const isAnId = (v: DropdownOptionValue) =>
    !!options.find((o) => o.value === v)
  const isAnObjectValue = (v: DropdownOptionValue) =>
    !!options.find((o) => v && JSON.stringify(o.value) === JSON.stringify(v))
  const isATextValue = (v: DropdownOptionValue) =>
    !!options.find((o) => v && o.text.trim() === (v + "").trim())
  const getIdForTextValue = (v: DropdownOptionValue) => {
    const found = options.find((o) => v && o.text.trim() === (v + "").trim())
    return found ? found.value : defaultValue
  }

  // console.log({ rawValue, value })

  switch (Array.isArray(rawValue)) {
    case false:
      // if (isMultiple) {
      //   return []
      // }
      if (isAnObjectValue(rawValue)) {
        value = rawValue
      } else if (isAnId(rawValue + "")) {
        value = rawValue + ""
      } else if (isATextValue(rawValue + "")) {
        value = getIdForTextValue(rawValue + "")
      }
      break

    case true:
      if (!Multilang.String.IsMultilangString(rawValue)) {
        value = (rawValue as number[]).map((m: any) => m + "")
        break
      }
      const ms = Multilang.String.CreateFrom(rawValue)
      const v = Multilang.String.GetValue(ms, getlangFromCache(), true)
      if (v) {
        if (isATextValue(v + "")) {
          value = getIdForTextValue(v + "")
        }
      }
      break
  }

  return value
}

interface IPreviousErrorMessageProps {
  content: React.ReactNode
  label: string
  fitted?: boolean
  fitContent?: boolean
  carriaged?: boolean
}
export const PreviousValueMessage = ({
  label,
  fitted = false,
  fitContent = false,
  carriaged = false,
  content,
}: IPreviousErrorMessageProps) => {
  let toDisplay
  // Multilang check in case of PIM changes
  if (Multilang.String.IsMultilangString(content)) {
    toDisplay = Multilang.String.GetValue(
      content as ILocalizedString[],
      getlangFromCache(),
      true
    )
  } else if (typeof content === "string") {
    toDisplay = (
      <div className={(carriaged ? "carriaged " : "") + "text"}>{content}</div>
    )
  } else {
    toDisplay = content
  }
  return (
    <Message
      className={
        (fitContent ? "fit-content " : "") +
        (fitted ? "fitted " : "") +
        "previous-value-message"
      }
      info
      // color="violet"
      content={
        <div className={(carriaged ? "carriaged " : "") + "content"}>
          <div className={(carriaged ? "carriaged " : "") + "header"}>
            {label + (carriaged ? "" : " : ")}
          </div>
          {toDisplay}
        </div>
      }
    />
  )
}
